import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PremiumTeaser = ({ feature, onClose, showModal = false }) => {
  const [isVisible, setIsVisible] = useState(showModal);

  const featureConfigs = {
    'feed': {
      icon: '👥',
      title: 'Discover Your Perfect Travel Companions',
      subtitle: 'Browse thousands of verified travelers and find your ideal match',
      benefits: [
        'Unlimited profile browsing',
        'Advanced search filters',
        'Personality compatibility scores',
        'Real-time availability status'
      ],
      cta: 'Start Free Trial',
      price: '£9.99/month'
    },
    'messages': {
      icon: '💬',
      title: 'Unlimited Messaging',
      subtitle: 'Connect freely with your travel companions',
      benefits: [
        'Send unlimited messages',
        'Share photos and travel plans',
        'Voice and video calls',
        'Group chat functionality'
      ],
      cta: 'Unlock Messaging',
      price: '£9.99/month'
    },
    'travel-groups': {
      icon: '✈️',
      title: 'Join Travel Groups',
      subtitle: 'Connect with organized trips and adventures',
      benefits: [
        'Join exclusive travel groups',
        'Create your own groups',
        'Access group discounts',
        'Travel with verified companions'
      ],
      cta: 'Join Groups',
      price: '£9.99/month'
    },
    'local-meets': {
      icon: '📍',
      title: 'Organize Local Meetups',
      subtitle: 'Create and join local events in your area',
      benefits: [
        'Create unlimited meetups',
        'Invite travelers to events',
        'Join sports and activities',
        'Organize restaurant outings'
      ],
      cta: 'Start Organizing',
      price: '£9.99/month'
    },
    'search': {
      icon: '🔍',
      title: 'Advanced Search & Filters',
      subtitle: 'Find exactly what you\'re looking for',
      benefits: [
        'Filter by age, location, interests',
        'Personality compatibility matching',
        'Travel style preferences',
        'Safety verification status'
      ],
      cta: 'Unlock Search',
      price: '£9.99/month'
    }
  };

  const config = featureConfigs[feature] || featureConfigs['feed'];

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  const handleUpgrade = () => {
    // Redirect to payment page
    window.location.href = '/payment';
  };

  if (!isVisible) return null;

  return (
    <div className="premium-teaser-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: 'var(--spacing-4)'
    }}>
      <div className="premium-teaser-modal" style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: 'var(--radius-xl)',
        padding: 'var(--spacing-8)',
        maxWidth: '500px',
        width: '100%',
        color: 'white',
        textAlign: 'center',
        position: 'relative',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Close Button */}
        <button 
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: 'var(--spacing-4)',
            right: 'var(--spacing-4)',
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            color: 'white',
            fontSize: '20px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          ×
        </button>

        {/* Feature Icon */}
        <div style={{ fontSize: '4em', marginBottom: 'var(--spacing-4)' }}>
          {config.icon}
        </div>

        {/* Title */}
        <h2 style={{ 
          fontSize: '1.8em', 
          marginBottom: 'var(--spacing-3)',
          fontWeight: 'bold'
        }}>
          {config.title}
        </h2>

        {/* Subtitle */}
        <p style={{ 
          fontSize: '1.1em', 
          marginBottom: 'var(--spacing-6)',
          opacity: 0.9,
          lineHeight: 1.5
        }}>
          {config.subtitle}
        </p>

        {/* Benefits */}
        <div style={{ 
          background: 'rgba(255, 255, 255, 0.1)', 
          padding: 'var(--spacing-4)', 
          borderRadius: 'var(--radius-md)',
          marginBottom: 'var(--spacing-6)'
        }}>
          <h3 style={{ marginBottom: 'var(--spacing-3)' }}>Premium Benefits:</h3>
          <ul style={{ 
            textAlign: 'left', 
            listStyle: 'none', 
            padding: 0,
            margin: 0
          }}>
            {config.benefits.map((benefit, index) => (
              <li key={index} style={{ 
                marginBottom: 'var(--spacing-2)',
                paddingLeft: 'var(--spacing-4)',
                position: 'relative'
              }}>
                <span style={{ 
                  position: 'absolute', 
                  left: 0, 
                  top: '2px',
                  color: '#4ade80',
                  fontSize: '1.2em'
                }}>✓</span>
                {benefit}
              </li>
            ))}
          </ul>
        </div>

        {/* Special Offer */}
        <div style={{ 
          background: 'rgba(255, 255, 255, 0.15)', 
          padding: 'var(--spacing-4)', 
          borderRadius: 'var(--radius-md)',
          marginBottom: 'var(--spacing-6)'
        }}>
          <div style={{ fontSize: '2em', marginBottom: 'var(--spacing-2)' }}>🎉</div>
          <h3 style={{ marginBottom: 'var(--spacing-2)' }}>Special Launch Offer!</h3>
          <p style={{ marginBottom: 'var(--spacing-3)', fontSize: '1.1em' }}>
            <strong>7-day free trial</strong><br/>
            Then only {config.price}
          </p>
        </div>

        {/* Action Buttons */}
        <div style={{ 
          display: 'flex', 
          gap: 'var(--spacing-3)', 
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button 
            onClick={handleUpgrade}
            style={{
              background: '#4ade80',
              border: 'none',
              color: 'white',
              padding: 'var(--spacing-3) var(--spacing-6)',
              borderRadius: 'var(--radius-md)',
              fontWeight: 'bold',
              fontSize: '1.1em',
              cursor: 'pointer',
              minWidth: '160px'
            }}
          >
            {config.cta}
          </button>
          <Link to="/pricing" style={{
            background: 'transparent',
            border: '2px solid white',
            color: 'white',
            padding: 'var(--spacing-3) var(--spacing-6)',
            borderRadius: 'var(--radius-md)',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '1.1em',
            minWidth: '160px',
            display: 'inline-block',
            textAlign: 'center'
          }}>
            View All Plans
          </Link>
        </div>

        {/* Trust Indicators */}
        <div style={{ 
          marginTop: 'var(--spacing-4)',
          fontSize: '0.9em',
          opacity: 0.8
        }}>
          <p>✓ Cancel anytime • ✓ No commitment • ✓ 30-day guarantee</p>
        </div>
      </div>
    </div>
  );
};

export default PremiumTeaser; 